import {useEffect, useState} from 'react'
import {Dispatch} from 'redux'
import moment from 'moment'
import '../accept-invite.scss'
import {formatSecondTime, handleNotificationWithToastify} from '../../../../services/Functional'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {AxiosResponse} from 'axios'

interface ResendOTPProps {
  className?: string
  APICalled: (dispatch: any) => Promise<void | AxiosResponse<any, any>>
  handleBackButton?: () => void
  showBackBtn?: boolean
}

export function ResendOTP({className, APICalled, handleBackButton, showBackBtn}: ResendOTPProps) {
  const dispatch: Dispatch<any> = useDispatch()
  let navigate = useNavigate()

  const countdownDurationShort = 30
  const countdownDurationLong = 120
  const maxAttempts = 3

  const [remainingTime, setRemainingTime] = useState(() => {
    const storedRemainingTime = localStorage.getItem('otpRemainingTime')
    return storedRemainingTime ? parseInt(storedRemainingTime) : countdownDurationShort
  })

  const [resendCount, setResendCount] = useState(() => {
    const storedResendCount = localStorage.getItem('otpResendCount')
    return storedResendCount ? parseInt(storedResendCount) : 0
  })

  const storedMaxResendCount = localStorage.getItem('otpMaxResendCount')
  const maxResendCount = storedMaxResendCount ? parseInt(storedMaxResendCount) : maxAttempts

  let intervalId: NodeJS.Timeout | undefined

  useEffect(() => {
    if (remainingTime > 0) {
      intervalId = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1)
      }, 1000)
    } else {
      clearInterval(intervalId!)
    }

    return () => {
      clearInterval(intervalId!)
    }
  }, [remainingTime])

  const onClickResendBtn = async () => {
    let response: any = await APICalled(dispatch)
    if (!response.success && response.code === 401) {
      navigate('/error/auth')
    } else if (!response.data.success) {
      handleNotificationWithToastify(response.data)
    } else if (response.status === 200 || response.status === 201) {
      if (resendCount < maxResendCount) {
        setResendCount((prevCount) => {
          const newCount = prevCount + 1
          localStorage.setItem('otpResendCount', newCount.toString())
          localStorage.setItem('otpResendTime', moment().valueOf().toString())
          localStorage.setItem('otpRemainingTime', countdownDurationShort.toString())
          return newCount
        })
        setRemainingTime(countdownDurationShort)
      } else {
        setResendCount(() => {
          const newCount = 0
          localStorage.setItem('otpResendCount', newCount.toString())
          localStorage.setItem('otpResendTime', moment().valueOf().toString())
          localStorage.setItem('otpRemainingTime', countdownDurationShort.toString())
          return newCount
        })
        setRemainingTime(countdownDurationLong)
      }
    } else {
      handleNotificationWithToastify(response?.data)
    }
  }

  useEffect(() => {
    localStorage.setItem('otpRemainingTime', remainingTime.toString())
    localStorage.setItem('otpResendCount', resendCount.toString())
    localStorage.setItem('otpMaxResendCount', maxResendCount.toString())
  }, [remainingTime, resendCount, maxResendCount])

  return (
    <div className={`d-flex justify-content-between ${showBackBtn && 'otp-btn-align'}`}>
      {showBackBtn && (
        <button
          className={`btn btn-link p-0 d-flex align-items-center resend-btn ${className} `}
          onClick={handleBackButton}
        >
          <i className='bi bi-chevron-left text-primary resend-back-button'></i>
          <u>Back to login</u>
        </button>
      )}
      {remainingTime !== 0 ? (
        <div className={`${className} resend-text mx-4`}>
          Resend Code in <span className='seconds'>00:{formatSecondTime(remainingTime)}</span>
        </div>
      ) : (
        <button
          className={`${className} btn btn-link p-0 d-flex resend-btn mx-4`}
          onClick={onClickResendBtn}
          disabled={remainingTime !== 0}
        >
          <u>Resend OTP</u>
        </button>
      )}
    </div>
  )
}
